import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {SplitterModule} from "primeng/splitter";
import {ButtonModule} from "primeng/button";
import {SignatureNavigationComponent} from "./signature-navigation/signature-navigation.component";
import {ProfilDataComponent} from "./profil-data/profil-data.component";
import {NgIf} from "@angular/common";
import {SignatureStandardsComponent} from "./signature-standards/signature-standards.component";
import {VisualSignatureComponent} from "./visual-signature/visual-signature.component";
import {SignatureSettingsComponent} from "./signature-settings/signature-settings.component";
import {RightContentComponent} from "../splitted-page/right-content/right-content.component";
import {TranslatePipe} from "@ngx-translate/core";
import {HttpErrorResponse} from "@angular/common/http";
import {UserService} from "../../shared/services/user.service";
import {FaqComponent} from "../../shared/components/faq/faq.component";
import {SubscriptionsService} from "../services/subscriptions.service";
import {Subscriptions} from "../model/subscriptions.models";

@Component({
    selector: 'app-signature',
    standalone: true,
    imports: [
        SplitterModule,
        ButtonModule,
        SignatureNavigationComponent,
        ProfilDataComponent,
        SignatureStandardsComponent,
        NgIf,
        VisualSignatureComponent,
        SignatureSettingsComponent,

        RightContentComponent,
        TranslatePipe,
        FaqComponent
    ],
    templateUrl: './signature.component.html',
    styleUrl: './signature.component.scss'
})
export class SignatureComponent implements OnInit {

    @Output() signEvent = new EventEmitter<string>();
    activeRightContent: string | null = null;
    loggedInUserData: any;
    userSubscription!: Subscriptions;


    constructor(private userService: UserService,
                private subscriptionsService: SubscriptionsService,) {
    }


    ngOnInit() {

        if (!this.activeRightContent) {
            this.activeRightContent = "home";
        }

        this.userService.getLoggedInUser().subscribe({
            next: (data) => {
                this.loggedInUserData = data;

            },
            error: (error: HttpErrorResponse) => {
                console.error('Error occurred while fetching user data:', {
                    status: error.status,
                    statusText: error.statusText,
                    message: error.message,
                    url: error.url
                });
            },
        });

        this.getUserSubscription();
    }

    changeRightContent($event: string): void {
        this.activeRightContent = $event;
    }

    sign($event: any) {
        this.signEvent.emit('sign');
    }

    getUserSubscription(): void {
        this.subscriptionsService.getCurrentUsersSubscriptions().subscribe({
            next: res => {
                this.userSubscription = res;
            },
            error: error => {
                console.error('ERROR: ', error);
            }
        })
    }
}
